import { setCookie } from 'cookies-next'
import { GROWTHBOOK_IS_ANGEL_EMPLOYEE_COOKIE } from '@/constants/cookies'
import { Durations } from '@/constants/durations'
import { growthbook } from '@/experimentation/client'
import { getIsAngelEmployeeUser } from '@/utils/users'
import { namedLogger } from '../utils'
import { type AnalyticsPlugin } from './types'

type AnalyticsEventParams<Payload extends object = object> = {
  payload: Payload
}

const logger = namedLogger('growthbook Analytics Plugin')

export function growthbookAnalyticsPlugin() {
  const plugin: AnalyticsPlugin = {
    name: 'growthbook',

    identify: ({
      payload,
    }: AnalyticsEventParams<{
      userId?: string
      anonymousId?: string
      traits?: {
        email?: string
        isMobile?: boolean
        isDesktop?: boolean
      }
    }>) => {
      const isAngelEmployeeUser = getIsAngelEmployeeUser(payload?.traits?.email)
      setCookie(GROWTHBOOK_IS_ANGEL_EMPLOYEE_COOKIE, String(isAngelEmployeeUser), {
        maxAge: Durations.ONE_YEAR_IN_SECONDS,
      })
      growthbook.setAttributes({
        ...growthbook.getAttributes(),
        id: payload?.anonymousId,
        userId: payload?.userId,
        isMobile: payload?.traits?.isMobile,
        isDesktop: payload?.traits?.isDesktop,
        isAngelEmployeeUser,
      })
    },

    page: ({
      payload,
    }: AnalyticsEventParams<{
      session_id?: string
    }>) => {
      // Update session_id when page events occur
      if (payload?.session_id) {
        growthbook.setAttributes({
          ...growthbook.getAttributes(),
          session_id: payload.session_id,
        })
      }
    },

    loaded() {
      logger.debug('Growthbook Analytics Plugin: loaded')
      return true
    },
  }

  return plugin
}
